function isString(value) {
    return typeof value === 'string';
}

export { isString };
